export class BookADemoModal {
    companyName!: string;
    contactName!: string;
    email!: string;
    phone!: string;
    noOfEmployees!: number;
    demoType: number = 1;
    skillGroupIds!: number[];
    locationInfo!: LocationModal;
    comment!: string;
    howDoYouHearAboutUs!: string;
    phoneNumberPrefix!: string;
    phoneNumCountryCode!: string;
    userDesignationId!: number;

    timezoneInfo: any;
    timezoneId!: any;
    demoTime!: Date;
    demoStartTime!: Date;
    demoEndTime!: Date;
    duration: Number = 30;
    executiveWorkId!: string;
    roleId!: number;
}

export class LocationModal {
    public cityId!: number;
    public stateId!: number;
    public countryId!: number;
    public cityName!: string;
    public stateName!: string;
    public countryName!: string;
    public formattedName!: string;
    public adminReviewStatusId!: number;
}